import { FormlyFieldConfig } from '@ngx-formly/core'
import _ from 'lodash'
import { env } from 'process'
import { STATE_PROVINCE_LIST } from 'src/data/address.form'
import { FORM_TO_COMBO } from 'src/data/form'
import { BR_APPLICATION_FIELDS, BR_FIELDS } from 'src/data/fields/br.fields'
import { CA_APPLICATION_FIELDS, CA_COUNTRY_FIELD, CA_FIELDS } from 'src/data/fields/ca.fields'
import { CN_APPLICATION_FIELDS, CN_FIELDS } from 'src/data/fields/cn.fields'
import { EMAIL_FIELD, FIRST_NAME_FIELD, LAST_NAME_FIELD, MIDDLE_NAME_FIELD, US_PHONE_NUMBER_FIELD, US_ADDRESS_FIELDS, INT_ADDRESS_FIELDS, EMPLOYMENT_STATUS_FIELD } from 'src/data/fields/generic.fields'
import { GH_APPLICATION_FIELDS, GH_FIELDS } from 'src/data/fields/gh.fields'
import { IN_APPLICATION_FIELDS, IN_FIELDS } from 'src/data/fields/in.fields'
import { KE_FIELDS, KE_APPLICATION_FIELDS } from 'src/data/fields/ke.fields'
import { KH_APPLICATION_FIELDS, KH_FIELDS } from 'src/data/fields/kh.fields'
import { KR_APPLICATION_FIELDS, KR_FIELDS } from 'src/data/fields/kr.fields'
import { LA_APPLICATION_FIELDS, LA_FIELDS } from 'src/data/fields/la.fields'
import { NZ_APPLICATION_FIELDS, NZ_FIELDS } from 'src/data/fields/nz.fields'
import { TG_APPLICATION_FIELDS, TG_FIELDS } from 'src/data/fields/tg.fields'
import { TZ_APPLICATION_FIELDS, TZ_FIELDS } from 'src/data/fields/tz.fields'
import { UK_APPLICATION_FIELDS, UK_FIELDS } from 'src/data/fields/uk.fields'
import { US_APPLICATION_FIELDS } from 'src/data/fields/us.fields'
import { VN_APPLICATION_FIELDS, VN_FIELDS } from 'src/data/fields/vn.fields'
import { environment } from 'src/environments/environment'

const gender_field = {
	type: 'buttons',
	props: {
		label: 'Gender',
		options: [
			{
				icon: 'icon-male',
				label: 'Male',
				value: 'male'
			},
			{
				icon: 'icon-female',
				label: 'Female',
				value: 'female'
			}
		]
	}
}

const nationality_field = {
	type: 'country-autocomplete',
	props: {
		label: 'Nationality',
	}
}

const nationalities_object = {
	answer: {
		type: 'yes-no-buttons'
	},
	list: {
		type: 'multiple',
		fieldArray: {
			fieldGroup: [
				{
					key: 'code',
					type: 'country-autocomplete',
					className: 'gwc-form__field gwc-form__field--grow'
				}
			]
		},
		defaultValue: [
			null
		]
	}
}

const relative_object = {
	employment_status: EMPLOYMENT_STATUS_FIELD,
	clan: {
		answer: {
			type: 'yes-no-buttons'
		},
		name: {
			type: 'name-field',
			props: {
				label: 'Name',
				required: true
			}
		}
	},
	unknown: {
		type: 'buttons',
		props: {
			options: [
				{
					label: 'Yes',
					value: 'no'
				},
				{
					label: 'No',
					value: 'yes'
				}
			],
		}
	},
	passport_scan: {
		props: {
			type: 'passport_scan',
			message: `Please take a picture of the applicant's mother’s passport showing the personal details page (the page with the photo and identifying information)`,
			friendly_name: 'Passport Scan'
		}
	},
	past_other_nationalities: nationalities_object,
	other_nationalities: nationalities_object,
	nationality: nationality_field,
	first_name: FIRST_NAME_FIELD,
	middle_name: MIDDLE_NAME_FIELD,
	last_name: LAST_NAME_FIELD,
	email: EMAIL_FIELD,
	birth_country: {
		type: 'country-autocomplete'
	},
	birth_city: {
		type: 'input',
		props: {
			label: 'City'
		}
	},
	birth_state: {
		type: 'state-province-autocomplete',
		props: {
			parentKey: 'birth_country'
		}
	},
	gender: {
		...gender_field,
		props: {
			...gender_field.props,
			defaultValue: 'female'
		}
	},
	us_citizen: {
		type: 'yes-no-buttons'
	},
	date_of_birth: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: '01/01/1900',
					message: 'Date of Birth must be after 01/01/1900'
				}
			],
			label: 'Date of Birth',
			before: [
				{
					date: 'now',
					message: 'Date can’t be in the future'
				},
				{
					key: 'date_of_birth',
					parent: 'global',
					message: 'Date can’t be after applicant’s date of birth'
				}
			],
			'required': true
		},
	}
}

const spouse_object = {
	address: {
		fieldGroup: INT_ADDRESS_FIELDS
	},
	...relative_object,
	date_of_birth: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: '01/01/1900',
					message: 'Date of Birth must be after 01/01/1900'
				}
			],
			label: 'Date of Birth',
			before: [
				{
					date: 'now',
					message: 'Date can’t be in the future'
				}
			],
			'required': true
		},
	},
	given_name: {
		type: 'name-field',
		props: {
			label: 'Given Names',
			maxLength: 33
		}
	},
	nationality: nationality_field
}

const country_specific_fields = {
	br: BR_FIELDS,
	ke: KE_FIELDS,
	in: IN_FIELDS,
	vn: VN_FIELDS,
	uk: UK_FIELDS,
	kr: KR_FIELDS,
	la: LA_FIELDS,
	kh: KH_FIELDS,
	tz: TZ_FIELDS,
	nz: NZ_FIELDS,
	gh: GH_FIELDS,
	tg: TG_FIELDS,
	cn: CN_FIELDS
}

const application_fields = {
	payment: {
		type: 'payment-module',
	},
	passport_photo: {
		choice: {
			type: 'choice-sections',
			props: {
				options: [
					{
						icon: 'icon-step-smartphone',
						label: 'Take a compliant photo with a smartphone. We will verify that all requirements are met and print it for you.',
						highlightText: 'From $15.95',
						value: 'online'
					},
					{
						icon: 'icon-step-location',
						label: 'Select a photo location from the most popular retailers and get your passport  photo in-person.',
						highlightText: 'Typically $15.95 - $17.99',
						value: 'in-person'
					}
				]
			}
		},
		photo: {
			props: {
				upsell: true,
				upsell_type: 'digital-photo',
				type: 'online_passport_photo',
				message: 'Take a picture on a white background. Make sure you are not wearing glasses, a hat or anything that covers your head (except for religious purposes), or any uniform.',
				model_type: 'application',
				friendly_name: 'Portrait-style photo',
				aspect_ratio: 1
			}
		}
	},
	idp: {
		type: {
			type: 'buttons',
			defaultValue: 'idp',
			props: {
				options: [
					{
						label: 'International Driving Permit (IDP)',
						value: 'idp'
					},
					{
						label: 'Inter-American Driving Permit (IADP)',
						value: 'iadp'
					}
				],
			}
		},
		countries: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						key: 'code',
						type: 'country-autocomplete',
						props: {
							excludes: [
								'US',
								'VN',
								'CN',
								'KP',
								'SO',
								'SS',
								'NG',
								'MN',
								'IQ',
								'ER',
								'ET'
							]
						},
						className: 'gwc-form__field gwc-form__field--grow'
					}
				]
			},
			defaultValue: [
				null
			]
		},
		departure_date: {
			type: 'datepicker',
			props: {
				view: 'year',
				after: [
					{
						days: 10,
						message: 'Departure date must be at least 10 days from today.',
						operation: 'add'
					}
				],
				label: 'US Departure Date',
			}
		},
		effective_date: {
			type: 'datepicker',
			props: {
				view: 'year',
				after: [
					{
						days: 10,
						message: 'Start date must be at least 10 days from today.',
						operation: 'add'
					}
				],
				label: 'IDP Start Date',
				before: [
					{
						months: 6,
						message: 'Start date must be within 6 months from today.',
						operation: 'add'
					}
				]
			}
		}
	},
	name_change_passport: {
		book: {
			type: 'yes-no-buttons',
		},
		card: {
			type: 'yes-no-buttons',
		},
		reason: {
			type: 'buttons',
			props: {
				options: [
					{
						label: 'Marriage',
						value: 'marriage'
					},
					{
						label: 'Court Order',
						value: 'court_order'
					}
				]
			}
		},
		place: {
			type: 'name-field',
			props: {
				label: 'Place of Name Change (City/State)',
				maxlength: 80
			}
		},
		date: {
			type: 'datepicker',
			props: {
				view: 'year',
				after: [
					{
						key: 'application.passport.issue_date',
						parent: 'global',
						message: `Date can’t be before passport's issue date`
					},
					{
						key: 'application.passport_card.issue_date',
						parent: 'global',
						message: `Date can’t be before passport card's issue date`
					}
				],
				label: 'Date of Name Change',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				],
			}
		}
	},
	date_of_entry: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: 'now',
					message: `Date can't be in the past.`
				}
			],
			label: 'Date of Entry',
			before: [
				{
					key: 'application.date_of_exit',
					parent: 'global',
					message: 'Date of Entry must be before Date of Exit.'
				}
			]
		}
	},
	entry_date: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: 'now',
					message: `Date can't be in the past.`
				}
			],
			label: 'Intended Date of Arrival'
		}
	},
	exit_date: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: 'now',
					message: `Date can't be in the past.`
				},
				{
					key: 'application.entry_date',
					parent: 'global',
					message: 'Date of Departure must be after Date of Arrival.'
				}
			],
			label: 'Intended Date of Departure'
		}
	},
	entry_origin_country: {
		type: 'country-autocomplete',
		props: {
			label: 'Country of Departure'
		}
	},
	destination_country: {
		type: 'country-autocomplete',
		props: {
			label: 'Country of Destination'
		}
	},
	entry_flight_number: {
		type: 'input',
		props: {
			label: 'Flight Number',
			maxLength: 20
		}
	},
	exit_flight_number: {
		type: 'input',
		props: {
			label: 'Flight Number',
			maxLength: 20
		}
	},
	return_ticket_available: {
		answer: {
			type: 'yes-no-buttons'
		}
	},
	return_confirmation: {
		props: {
			type: 'pdf_document',
			message: 'Please take a picture or upload a copy of your onward or return ticket showing departure from Ghana.',
			friendly_name: 'Return Travel Confirmation'
		}
	},
	date_of_exit: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: 'now',
					message: `Date can't be in the past.`
				},
				{
					key: 'application.date_of_entry',
					parent: 'global',
					message: 'Date of Exit must be after Date of Entry.'
				}
			],
			label: 'Date of Exit'
		}
	},
	br: BR_APPLICATION_FIELDS,
	ke: KE_APPLICATION_FIELDS,
	in: IN_APPLICATION_FIELDS,
	vn: VN_APPLICATION_FIELDS,
	uk: UK_APPLICATION_FIELDS,
	us: US_APPLICATION_FIELDS,
	kr: KR_APPLICATION_FIELDS,
	la: LA_APPLICATION_FIELDS,
	kh: KH_APPLICATION_FIELDS,
	tz: TZ_APPLICATION_FIELDS,
	nz: NZ_APPLICATION_FIELDS,
	gh: GH_APPLICATION_FIELDS,
	tg: TG_APPLICATION_FIELDS,
	ca: CA_APPLICATION_FIELDS,
	cn: CN_APPLICATION_FIELDS,
	applied_for_passport: {
		type: 'buttons',
		props: {
			options: [
				{
					label: 'Yes',
					value: 'yes'
				},
				{
					label: 'No',
					value: 'no'
				}
			],
			'defaultValue': 'no'
		}
	},
	lost_passport_history: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: 'number',
								type: 'input',
								props: {
									label: 'Passport Number',
									maxLength: 20
								}
							},
							{
								key: 'issued_at.country',
								type: 'country-autocomplete',
								props: {
									label: 'Country of Issue'
								}
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						key: 'description',
						type: 'input',
						props: {
							label: 'Description',
							maxLength: 1000
						}
					}
				]
			}
		},
		other: {
			answer: {
				type: 'yes-no-buttons'
			},
			frequency: {
				type: 'input',
				props: {
					'min': 0,
					'step': 1,
					type: 'number',
					label: 'Number of times',
				}
			},
			police_report: {
				type: 'yes-no-buttons'
			},
			dates: {
				type: 'multiple',
				'fieldArray': {
					fieldGroup: [
						{
							key: 'date',
							type: 'datepicker',
							props: {
								view: 'multi-year',
								after: [
									{
										key: 'date_of_birth',
										parent: 'global',
										message: `Date can't be before applicant’s date of birth`
									}
								],
								label: 'Date',
								before: [
									{
										date: 'now',
										message: 'Date can’t be in the future'
									},
									{
										key: 'passport.issue_date',
										parent: 'global',
										message: `Date can’t be after passport's issue date`
									},
									{
										key: 'passport_card.issue_date',
										parent: 'global',
										message: `Date can’t be after passport card's issue date`
									}
								],
								'required': true
							},
							className: 'gwc-form__field gwc-form__field--grow'
						}
					]
				},
				'defaultValue': [
					null
				]
			}
		}
	},
	lost_passport: {
		how: {
			type: 'input',
			props: {
				label: 'Please provide a brief description',
				maxLength: 115
			},
			'validation': {
				messages: {
					maxLength: 'The description must be less than 115 characters.'
				}
			}
		},
		where: {
			type: 'input',
			props: {
				label: 'Please provide address if known',
				maxLength: 115
			},
			'validation': {
				messages: {
					maxLength: 'The address must be less than 115 characters.'
				}
			}
		},
		when: {
			type: 'datepicker',
			props: {
				after: [
					{
						key: 'application.passport.issue_date',
						parent: 'global',
						message: `Date can’t be before passport's issue date`
					},
					{
						key: 'application.passport_card.issue_date',
						parent: 'global',
						message: `Date can’t be before passport card's issue date`
					}
				],
				label: 'The last time you remember them in your possession',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				],
				start_view: 'year'
			}
		},
		police_report: {
			type: 'yes-no-buttons'
		},
		police_report_copy: {
			type: 'yes-no-buttons'
		}
	},
	passport: {
		not_in_possession: {
			issue_date_available: {
				type: 'yes-no-buttons'
			},
			issue_date: {
				type: 'buttons',
				props: {
					options: [
						{
							label: 'Yes',
							value: 'yes'
						},
						{
							label: 'No',
							value: 'no'
						},
						{
							label: 'Unknown',
							value: 'unknown'
						}
					]
				}
			}
		},
		type: {
			type: 'select',
			props: {
				label: 'Passport Type',
				options: [
					{
						label: 'Regular',
						value: 'regular'
					},
					{
						label: 'Diplomatic',
						value: 'diplomatic'
					},
					{
						label: 'Official',
						value: 'official'
					}
				]
			}
		},
		in_possession: {
			type: 'buttons',
			props: {
				options: [
					{
						label: 'Yes',
						value: 'yes'
					},
					{
						label: 'No, it was lost',
						value: 'lost'
					},
					{
						label: 'No, it was stolen',
						value: 'stolen'
					}
				],
			}
		},
		is_damaged: {
			type: 'yes-no-buttons'
		},
		first_name: FIRST_NAME_FIELD,
		middle_name: MIDDLE_NAME_FIELD,
		last_name: LAST_NAME_FIELD,
		number: {
			type: 'input',
			props: {
				label: 'Passport Number',
				pattern: '[a-zA-Z0-9]{1}[0-9]{8}',
				maxLength: 9
			}
		},
		issuer: {
			type: 'input',
			props: {
				label: 'Issuing Authority/Place of Issue'
			}
		},
		issue_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						key: 'date_of_birth',
						parent: 'global',
						message: `Date can't be before Date of Birth`
					}
				],
				label: 'Issue Date',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				],
			}
		},
		expiry_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						date: 'now',
						message: 'Date can’t be in the past'
					}
				],
				label: 'Date of Expiry',
			}
		}
	},
	passport_card: {
		not_in_possession: {
			issue_date_available: {
				type: 'yes-no-buttons'
			},
			issue_date: {
				type: 'buttons',
				props: {
					options: [
						{
							label: 'Yes',
							value: 'yes'
						},
						{
							label: 'No',
							value: 'no'
						},
						{
							label: 'Unknown',
							value: 'unknown'
						}
					]
				}
			}
		},
		in_possession: {
			type: 'buttons',
			props: {
				options: [
					{
						label: 'Yes',
						value: 'yes'
					},
					{
						label: 'No, it was lost',
						value: 'lost'
					},
					{
						label: 'No, it was stolen',
						value: 'stolen'
					}
				],
			}
		},
		is_damaged: {
			type: 'yes-no-buttons'
		},
		first_name: FIRST_NAME_FIELD,
		middle_name: MIDDLE_NAME_FIELD,
		last_name: LAST_NAME_FIELD,
		number: {
			type: 'input',
			props: {
				label: 'Passport Card Number',
				pattern: '[a-zA-Z]{1}[0-9]{8}',
				'required': true,
				maxLength: 9
			},
		},
		issue_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						key: 'date_of_birth',
						parent: 'global',
						message: `Date can't be before Date of Birth`
					},
					{
						date: '07/12/2008',
						message: 'Date can’t be before 07/12/2008'
					}
				],
				label: 'Issue Date',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				],
			}
		},
		expiry_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						date: 'now',
						message: 'Date can’t be in the past'
					}
				],
				label: 'Date of Expiry',
			}
		}
	},
	flight_confirmation: {
		props: {
			type: 'pdf_document',
			message: 'Please take a picture or upload a screenshot of the flight confirmation.',
			friendly_name: 'Flight Confirmation'
		}
	},
	hotel_booking: {
		props: {
			type: 'pdf_document',
			message: 'Please take a picture or upload a screenshot of the hotel booking.',
			friendly_name: 'Hotel Booking'
		}
	}
}

const education_level_options = [
	{
		label: 'No Education',
		value: 'none'
	},
	{
		label: 'Some High School (Under 10th Grade)',
		value: 'high_school_under_10th_grade'
	},
	{
		label: 'Some High School (Above 10th Grade)',
		value: 'high_school_above_10th_grade'
	},
	{
		label: 'High School Diploma',
		value: 'high_school'
	},
	{
		label: `Bachelor's Degree`,
		value: 'bachelor'
	},
	{
		label: `Master's Degree`,
		value: 'master'
	},
	{
		label: 'Doctoral Degree',
		value: 'doctoral'
	},
	{
		label: 'Professional Degree',
		value: 'professional'
	}
]

const fields: { [key: string]: any } = {
	languages: {
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'language',
						type: 'input',
						props: {
							label: 'Language',
							required: true,
							maxLength: 66
						}
					}
				]
			}
		}
	},
	aa_location: {
		type: 'location-finder',
		props: {
			heading: 'Find an Acceptance Agent location near you.',
			category: 'passport-acceptance'
		}
	},
	photo_location: {
		type: 'location-finder',
		props: {
			heading: 'Find a location to get your Passport Photo taken.',
			category: 'passport-photo'
		}
	},
	online_passport_photo: {
		props: {
			message: 'Take a picture on a white background. Make sure you are not wearing glasses, a hat or anything that covers your head (except for religious purposes), or any uniform.',
			model_type: 'profile',
			friendly_name: 'Portrait-style photo',
			aspect_ratio: 1
		}
	},
	nationality_acquisition: {
		type: 'buttons',
		props: {
			options: [
				{
					label: 'By Birth',
					value: 'birth'
				},
				{
					label: 'By Naturalization',
					value: 'naturalization'
				}
			]
		}
	},
	citizenship: nationality_field,
	...country_specific_fields,
	...CA_FIELDS,
	birth_certificate_scan: {
		props: {
			message: `Please take a picture of the applicant's birth certificate.`,
			friendly_name: 'Birth Certificate Scan'
		}
	},
	nationalities: nationalities_object,
	permanent_resident: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						key: 'code',
						type: 'country-autocomplete',
					}
				],
				fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
			}
		}
	},
	national_id_number: {
		answer: {
			type: 'yes-no-buttons'
		},
		value: {
			type: 'input',
		}
	},
	first_name: FIRST_NAME_FIELD,
	middle_name: MIDDLE_NAME_FIELD,
	last_name: LAST_NAME_FIELD,
	last_name_at_birth: {
		type: 'name-field',
		props: {
			label: 'Last Name at Birth',
		}
	},
	birth_country: {
		type: 'country-autocomplete',
		props: {
			commonly_used: [
				{
					label: 'United States',
					value: 'US'
				},
				{
					label: 'Canada',
					value: 'CA'
				}
			]
		},
		hooks: {
			onChanges: (field: any) => {
				// Set initial value if birth_country has a value and nationality_at_birth is empty
				if (field.formControl?.value && field.model && !field.model.nationality_at_birth) {
					field.model.nationality_at_birth = field.formControl.value
				}
				// Sync on changes
				field.formControl?.valueChanges.subscribe((value: string) => {
					console.log('value', value, field.model)
					if (value && field.model && !field.model.nationality_at_birth) {
						field.model.nationality_at_birth = value
					}
				})
			}
		}
	},
	nationality_at_birth: {
		type: 'country-autocomplete',
		props: {
			label: 'Nationality at Birth',
		}
	},
	birth_city: {
		type: 'input',
		props: {
			label: 'City',
			pattern: `^[a-zA-Z\\s\\-']*$`,
		},
		validation: {
			messages: {
				pattern: 'Please use only letters, spaces, dashes and apostrophes.'
			}
		}
	},
	birth_state: {
		type: 'state-province-autocomplete',
		props: {
			parentKey: 'birth_country',
			parentDetailKey: 'ca.birth_country_detail'
		}
	},
	date_of_birth: {
		type: 'datepicker',
		props: {
			view: 'multi-year',
			after: [
				{
					date: '01/01/1800',
					message: 'Date of Birth must be after 01/01/1800'
				}
			],
			label: 'Date of Birth',
			before: [
				{
					date: 'now',
					message: 'Date can’t be in the future'
				}
			]
		}
	},
	nationality: nationality_field,
	passport_scan: {
		props: {
			type: 'passport_scan',
			message: 'Please take a picture of the personal details page.',
			friendly_name: 'Passport Scan'
		}
	},
	gender: gender_field,
	marital_status: {
		type: 'select',
		props: {
			label: 'Marital Status',
			options: [
				{
					label: 'Single',
					value: 'single'
				},
				{
					label: 'Divorced',
					value: 'divorced'
				},
				{
					label: 'Widowed',
					value: 'widowed'
				},
				{
					label: 'Separated',
					value: 'separated'
				}
			]
		}
	},
	height: {
		feet: {
			type: 'input',
			props: {
				max: 10,
				min: 1,
				step: 1,
				type: 'number',
				label: 'Feet',
				required: true
			},
			validation: {
				messages: {
					max: 'This value must be between 1 and 10 feet.',
					min: 'This value must be between 1 and 10 feet.'
				}
			},
			validators: {
				validation: [
					'decimal'
				]
			},
		},
		inches: {
			type: 'input',
			props: {
				max: 11,
				min: 0,
				step: 1,
				type: 'number',
				label: 'Inches',
				required: true
			},
			validation: {
				messages: {
					max: 'This value must be between 0 and 11 inches.',
					min: 'This value must be between 0 and 11 inches.'
				}
			},
			validators: {
				validation: [
					'decimal'
				]
			}
		},
	},
	hair_color: {
		type: 'select',
		props: {
			label: 'Natural Hair Color',
			options: [
				{
					label: 'Black',
					value: 'black'
				},
				{
					label: 'Blonde',
					value: 'blonde'
				},
				{
					label: 'Brown',
					value: 'brown'
				},
				{
					label: 'Red',
					value: 'red'
				},
				{
					label: 'Gray',
					value: 'gray'
				},
				{
					label: 'Bald',
					value: 'bald'
				},
				{
					label: 'Other',
					value: 'other'
				}
			]
		}
	},
	eye_color: {
		type: 'select',
		props: {
			label: 'Natural Eye Color',
			options: [
				{
					label: 'Amber',
					value: 'amber'
				},
				{
					label: 'Black',
					value: 'black'
				},
				{
					label: 'Blue',
					value: 'blue'
				},
				{
					label: 'Brown',
					value: 'brown'
				},
				{
					label: 'Gray',
					value: 'gray'
				},
				{
					label: 'Green',
					value: 'green'
				},
				{
					label: 'Hazel',
					value: 'hazel'
				}
			]
		}
	},
	drivers_license: {
		vehicles: {
			type: 'multi-select',
			props: {
				options: [
					{
						label: 'Motorcycle',
						value: 'motorcycle'
					},
					{
						label: 'Passenger Car',
						value: 'passenger'
					},
					{
						label: 'Vehicle Over 7,700lbs',
						value: 'over_7700lbs'
					},
					{
						label: 'Vehicle Over 8 Seats',
						value: 'over_8seats'
					},
					{
						label: 'Vehicle with Heavy Trailer',
						value: 'heavy_trailer'
					}
				]
			},
			defaultValue: []
		},
		expiration_date: {
			type: 'datepicker',
			props: {
				view: 'year',
				after: [
					{
						date: 'now',
						message: 'Date can’t be in the past'
					}
				],
				label: 'Expiration Date'
			}
		},
		number: {
			type: 'input',
			props: {
				label: `Driver's License Number`,
			}
		},
		address: {
			fieldGroup: [
				{
					fieldGroup: [
						{
							key: 'address_1',
							type: 'input',
							props: {
								label: 'Street Address 1',
								required: true
							},
							className: 'gwc-form__field gwc-form__field--grow'
						},
						{
							key: 'address_2',
							type: 'input',
							props: {
								label: 'Suite/Apt',
								required: false
							},
							className: 'gwc-form__field gwc-form__field--apt'
						}
					],
					fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
				},
				{
					fieldGroup: [
						{
							key: 'city',
							type: 'name-field',
							props: {
								label: 'City',
								required: true
							},
							className: 'gwc-form__field gwc-form__field--grow'
						},
						{
							key: 'state',
							type: 'state-province-autocomplete',
							props: {
								required: true,
								parentValue: 'US'
							},
							className: 'gwc-form__field gwc-form__field--grow'
						},
						{
							key: 'zip',
							type: 'input',
							props: {
								label: 'Zip',
								pattern: '[0-9]{5}',
								required: true,
								maxLength: 5
							},
							className: 'gwc-form__field gwc-form__field--apt'
						}
					],
					fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
				}
			]
		},
	},
	int_address: {
		fieldGroup: INT_ADDRESS_FIELDS,
	},
	address: {
		country: CA_COUNTRY_FIELD,
		fieldGroup: [
			{
				fieldGroup: [
					{
						key: "number",
						type: "input",
						props: {
							label: "Number",
							maxLength: 5,
							pattern: "^[ \\-a-zA-Z0-9]*$",
							required: true
						},
						className: "gwc-form__field gwc-form__field--grow gwc-form__field--small",
						validators: {
							validation: [
								"pobox"
							]
						}
					},
					{
						key: "street",
						type: "input",
						props: {
							label: "Street",
							maxLength: 30,
							required: true
						},
						className: "gwc-form__field gwc-form__field--grow",
						validators: {
							validation: ["pobox"]
						}
					},
					{
						key: 'apt',
						type: 'input',
						props: {
							label: 'Suite/Apt',
							required: false
						},
						className: 'gwc-form__field gwc-form__field--apt',
						validators: {
							validation: [
								'pobox'
							]
						}
					}
				],
				fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
			},
			{
				fieldGroup: [
					{
						key: 'address_1',
						type: 'input',
						props: {
							label: 'Street Address 1',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow',
						validators: {
							validation: [
								'pobox'
							]
						}
					},
					{
						key: 'address_2',
						type: 'input',
						props: {
							label: 'Suite/Apt',
							required: false
						},
						className: 'gwc-form__field gwc-form__field--apt',
						validators: {
							validation: [
								'pobox'
							]
						}
					}
				],
				fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
			},
			{
				fieldGroup: [
					{
						key: 'city',
						type: 'name-field',
						props: {
							label: 'City',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						key: "state",
						type: "autocomplete",
						props: {
							required: true,
							mappedOptions: STATE_PROVINCE_LIST,
						},
						expressions: {
							'props.label': (field: FormlyFieldConfig) => {
								const parent = field.parent?.parent
								const country = parent ? parent?.model?.country || parent.parent?.props?.['country'] : null
								
								return country === 'CA' ? 'Province' : 'State'
							},
							'props.options': (field: FormlyFieldConfig) => {
								const parent = field.parent?.parent
								const country = parent ? parent?.model?.country || parent.parent?.props?.['country'] : null
								console.log(field.props?.['mappedOptions'][country])
								return field.props?.['mappedOptions'][country || 'US']
							}
						},
						className: "gwc-form__field gwc-form__field--grow"
					},
					{
						key: "zip",
						type: "input",
						props: {
							label: "Zip",
							required: true
						},
						className: "gwc-form__field gwc-form__field--grow gwc-form__field--small",
						expressions: {
							'props.pattern': (field: FormlyFieldConfig) => {
								const country = field.formControl?.parent?.get('country')?.value || field.model?.country || field.parent?.parent?.parent?.props?.['country']
					
								return country === 'CA' ? '[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz] \\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\\d' : '[0-9]{5}'
							},
							'props.maxLength': (field: FormlyFieldConfig) => {
								const country = field.formControl?.parent?.get('country')?.value || field.model?.country
					
								return country === 'CA' ? 7 : 5
							},
						}
					}
				],
				fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
			}
		]
	},

	mailing_address: {
		address: {
			country: CA_COUNTRY_FIELD,
			fieldGroup: [
				{
					fieldGroup: [
						{
							key: "number",
							type: "input",
							props: {
								label: "Number",
								maxLength: 5,
								pattern: "^[ \\-a-zA-Z0-9]*$",
								required: true
							},
							className: "gwc-form__field gwc-form__field--grow gwc-form__field--small",
							validators: {
								validation: [
									"pobox"
								]
							}
						},
						{
							key: "street",
							type: "input",
							props: {
								label: "Street",
								maxLength: 30,
								required: true
							},
							className: "gwc-form__field gwc-form__field--grow",
							validators: {
								validation: ["pobox"]
							}
						},
						{
							key: 'apt',
							type: 'input',
							props: {
								label: 'Suite/Apt',
								required: false
							},
							className: 'gwc-form__field gwc-form__field--apt',
							validators: {
								validation: [
									'pobox'
								]
							}
						}
					],
					fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
				},
				{
					fieldGroup: [
						{
							key: 'address_1',
							type: 'input',
							props: {
								label: 'Street Address 1',
								required: true
							},
							className: 'gwc-form__field gwc-form__field--grow',
							validators: {
								validation: [
									'pobox'
								]
							}
						},
						{
							key: 'address_2',
							type: 'input',
							props: {
								label: 'Suite/Apt',
								required: false
							},
							className: 'gwc-form__field gwc-form__field--apt',
							validators: {
								validation: [
									'pobox'
								]
							}
						}
					],
					fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
				},
				{
					fieldGroup: [
						{
							key: 'city',
							type: 'name-field',
							props: {
								label: 'City',
								required: true
							},
							className: 'gwc-form__field gwc-form__field--grow'
						},
						{
							key: "state",
							type: "autocomplete",
							props: {
								required: true,
								mappedOptions: STATE_PROVINCE_LIST,
							},
							expressions: {
								'props.label': (field: FormlyFieldConfig) => {
									const parent = field.parent?.parent
									const country = parent ? parent?.model?.country || parent.parent?.props?.['country'] : null
									
									return country === 'CA' ? 'Province' : 'State'
								},
								'props.options': (field: FormlyFieldConfig) => {
									const parent = field.parent?.parent
									const country = parent ? parent?.model?.country || parent.parent?.props?.['country'] : null
						
									console.log(field.props?.['mappedOptions'][country])
									return field.props?.['mappedOptions'][country || 'US']
								}
							},
							className: "gwc-form__field gwc-form__field--grow"
						},
						{
							key: "zip",
							type: "input",
							props: {
								label: "Zip",
								required: true
							},
							className: "gwc-form__field gwc-form__field--grow gwc-form__field--small",
							expressions: {
								'props.pattern': (field: FormlyFieldConfig) => {
									const country = field.formControl?.parent?.get('country')?.value || field.model?.country || field.parent?.parent?.parent?.props?.['country']
						
									return country === 'CA' ? '[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz] \\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\\d' : '[0-9]{5}'
								},
								'props.maxLength': (field: FormlyFieldConfig) => {
									const country = field.formControl?.parent?.get('country')?.value || field.model?.country
						
									return country === 'CA' ? 7 : 5
								},
							}
						}
					],
					fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
				}
			]
		},
		int_address: {
			fieldGroup: INT_ADDRESS_FIELDS,
		},
		same: {
			type: 'yes-no-buttons'
		},
	},
	"proof_of_identity": {
		"primary": {
			"type": {
				"type": "input",
				"props": {
					"label": "Document Type",
					"required": true,
					"maxLength": 24
				},
				"className": "gwc-form__field gwc-form__field--grow",
				"validation": {
					"messages": {
						"maxLength": "Document type must be less than 24 characters."
					}
				}
			},
			"number": {
				"type": "input",
				"props": {
					"label": "Document Number",
					"required": true,
					"maxLength": 22
				},
				"className": "gwc-form__field gwc-form__field--grow",
				"validation": {
					"messages": {
						"maxLength": "Document number must be less than 22 characters."
					}
				}
			},
			"expiration_date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"date": "now",
							"message": "Date can’t be in the past"
						}
					],
					"label": "Expiration Date",
					"required": false
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"name": {
				"type": "name-field",
				"props": {
					"label": "Name as Appearce on the Document",
					"required": true
				},
				"className": "gwc-form__field gwc-form__field--grow"
			}
		},
		"add_secondary": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"secondary": {
			"type": {
				"type": "input",
				"props": {
					"label": "Document Type",
					"required": true,
					"maxLength": 24
				},
				"className": "gwc-form__field gwc-form__field--grow",
				"validation": {
					"messages": {
						"maxLength": "Document type must be less than 24 characters."
					}
				}
			},
			"number": {
				"type": "input",
				"props": {
					"label": "Document Number",
					"required": true,
					"maxLength": 22
				},
				"className": "gwc-form__field gwc-form__field--grow",
				"validation": {
					"messages": {
						"maxLength": "Document number must be less than 22 characters."
					}
				}
			},
			"expiration_date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"date": "now",
							"message": "Date can’t be in the past"
						}
					],
					"label": "Expiration Date",
					"required": false
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"name": {
				"type": "name-field",
				"props": {
					"label": "Name as Appearce on the Document",
					"required": true
				},
				"className": "gwc-form__field gwc-form__field--grow"
			}
		}
	},
	employment: {
		list: {
			"type": "multiple",
			"fieldArray": {
				"fieldGroup": [
					{
						"key": "type",
						"type": "buttons",
						"props": {
							"options": [
								{
									"label": "Employed",
									"value": "employed"
								},
								{
									"label": "In School",
									"value": "school"
								},
								{
									"label": "Unemployed",
									"value": "unemployed"
								}
							],
							"required": true
						},
						"className": "gwc-form__field gwc-form__field--tight"
					},
					{
						"fieldGroup": [
							{
								"fieldGroup": [
									{
										"key": "name",
										"type": "input",
										"props": {
											"required": true
										},
										"className": "gwc-form__field gwc-form__field--grow gwc-form__field--tight",
										"expressions": {
											"props.label": "model?.type === 'employed' ? 'Employeer' : 'School'"
										}
									},
									{
										"key": "phone_number",
										"type": "masked-input",
										"props": {
											"mask": "(000) 000-0000",
											"label": "Phone Number"
										},
										"className": "gwc-form__field gwc-form__field--grow gwc-form__field--grow"
									}
								],
								"fieldGroupClassName": "gwc-form__field-group gwc-form__field-group--row"
							},
							{
								"key": "field",
								"type": "input",
								"props": {
									"required": false
								},
								"className": "gwc-form__field gwc-form__field--grow gwc-form__field--tight",
								"expressions": {
									"props.label": "model?.type === 'employed' ? 'Field of Employment' : 'Field of Studies'"
								}
							},
							{
								"key": "address.country",
								"type": "country-autocomplete",
								"props": {
									"required": false
								},
								"className": "gwc-form__field gwc-form__field--grow gwc-form__field--tight"
							},
							{
								"key": "address",
								"type": "ca-plain-address"
							}
						],
						"expressions": {
							"hide": "!(['employed', 'school'].includes(model?.type))"
						}
					},
					{
						"key": "unemployed_detail",
						"type": "select",
						"props": {
							"label": "Please specify unemployment status",
							"options": [
								{
									"label": "Homemaker",
									"value": "homemaker"
								},
								{
									"label": "Retired",
									"value": "retired"
								},
								{
									"label": "Unemployed",
									"value": "unemployed"
								}
							],
							"required": true
						},
						"className": "gwc-form__field gwc-form__field--grow",
						"expressions": {
							"hide": "!(['unemployed'].includes(model?.type))"
						}
					},
					{
						// steps-path filterFieldGroup drops keyless component entries, so
						// inline the combo's keyed fields for subkeys to select
						fieldGroup: FORM_TO_COMBO,
						fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
					}
				]
			},
			"defaultValue": [
				null
			]
		}
	},
	address_history: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						key: 'address',
						type: 'ca-plain-address-country'
					},
					{
						// steps-path filterFieldGroup drops keyless component entries, so
						// inline the combo's keyed fields for subkeys to select
						fieldGroup: FORM_TO_COMBO,
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					}
				]
			},
			defaultValue: [
				null
			]
		}
	},
	education: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: 'institution',
								type: 'input',
								props: {
									label: 'Institution',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'course_of_study',
								type: 'input',
								props: {
									label: 'Course of Study',
									required: true,
									maxLength: 66
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'degree',
								type: 'select',
								props: {
									label: 'Diploma/Degree',
									required: true,
									options: education_level_options
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
						]
					},
					{
						fieldGroup: [
							{
								key: 'start_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'Start Date',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'end_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'End Date',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						]
					},
					{
						template: '<div class=\'gwc-form__label\'>Address of Institution</div>'
					},
					{
						fieldGroup: [
							{
								key: 'address_1',
								type: 'input',
								props: {
									label: 'Address 1',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						]
					},
					{
						fieldGroup: [
							{
								key: 'city',
								type: 'input',
								props: {
									label: 'City',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'state',
								type: 'input',
								props: {
									label: 'State',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'zip',
								type: 'input',
								props: {
									label: 'Zip',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						]
					},
					{
						key: 'country',
						type: 'country-autocomplete',
						props: {
							label: 'Country',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					}
				],
				fieldGroupClassName: 'gwc-form__field-group'
			},
			defaultValue: [
				null
			]
		},
		highest_level: {
			type: 'select',
			props: {
				label: 'Highest Level of Education',
				options: education_level_options
			}
		},
		qualification: {
			type: 'input',
			props: {
				label: 'Qualification',
				maxLength: 50
			}
		}
	},
	other_passports: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: 'nationality',
								type: 'country-autocomplete',
								label: 'Nationality',
								props: {
									label: 'Nationality'
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'passport.number',
								type: 'input',
								props: {
									label: 'Passport Number',
									pattern: '[a-zA-Z0-9]{7,9}',
									required: true
								},
								// TODO: FIX ME
								// expressions: {
								// 	'props.pattern': `model.citizenship === 'US' ? '[a-zA-Z0-9]{9}' : '[a-zA-Z0-9]{7,9}'`
								// },
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						key: 'passport.issuer',
						type: 'input',
						props: {
							label: 'Issuing Authority/Place of Issue',
							required: false
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						fieldGroup: [
							{
								key: 'passport.issue_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'Date of Issue',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'passport.expiry_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'Date of Expiry',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					}
				]
			},
			defaultValue: [
				null
			]
		}
	},
	religion: {
		type: 'name-field',
		props: {
			label: 'Religion',
			maxLength: 41
		}
	},
	visible_identification_marks: {
		answer: {
			type: 'yes-no-buttons'
		},
		description: {
			type: 'input',
			props: {
				pattern: '^[a-zA-Z ]*$',
				label: 'Visible Identification Marks',
			},
			validation: {
				messages: {
					pattern: 'Please use only letters and spaces.'
				}
			}
		}
	},
	social_media: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'platform',
						type: 'select',
						props: {
							label: 'Platform',
							options: [
								{ label: 'ASK.FM', value: 'ASKF' },
								{ label: 'DOUBAN', value: 'DUBN' },
								{ label: 'FACEBOOK', value: 'FCBK' },
								{ label: 'FLICKR', value: 'FLKR' },
								{ label: 'GOOGLE+', value: 'GOGL' },
								{ label: 'INSTAGRAM', value: 'INST' },
								{ label: 'LINKEDIN', value: 'LINK' },
								{ label: 'MYSPACE', value: 'MYSP' },
								{ label: 'PINTEREST', value: 'PTST' },
								{ label: 'QZONE (QQ)', value: 'QZNE' },
								{ label: 'REDDIT', value: 'RDDT' },
								{ label: 'SINA WEIBO', value: 'SWBO' },
								{ label: 'TENCENT WEIBO', value: 'TWBO' },
								{ label: 'TUMBLR', value: 'TUMB' },
								{ label: 'TWITTER', value: 'TWIT' },
								{ label: 'TWOO', value: 'TWOO' },
								{ label: 'VINE', value: 'VINE' },
								{ label: 'VKONTAKTE (VK)', value: 'VKON' },
								{ label: 'YOUKU', value: 'YUKU' },
								{ label: 'YOUTUBE', value: 'YTUB' }
							]
						}
					},
					{
						key: 'username',
						type: 'input',
						props: {
							label: 'Username',
							maxLength: 50
						}
					}
				]
			}
		}
	},
	social_media_other: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'platform',
						type: 'input',
						props: {
							label: 'Platform',
							maxLength: 40
						}
					},
					{
						key: 'username',
						type: 'input',
						props: {
							label: 'Username',
							maxLength: 40
						}
					}
				]
			}
		}
	},
	contact_phone_home: US_PHONE_NUMBER_FIELD,
	contact_phone_extra: {
		type: 'masked-input',
		props: {
			mask: '(000) 000-0000',
			label: 'Additional Number',
			required: false
		}
	},
	int_contact_phone_home: {
		type: 'input',
		props: {
			label: 'Primary Phone Number',
		}
	},
	int_contact_phone_extra: {
		type: 'input',
		props: {
			label: 'Secondary Phone Number',
		}
	},
	int_contact_phone_work: {
		type: 'input',
		props: {
			label: 'Work Phone Number',
		}
	},
	contact_email: {
		type: 'input',
		props: {
			label: 'Email',
			pattern: `\\w+([\\-+._']\\w+)*@\\w+([\\-._]\\w+)*\\.\\w+([\\-.]\\w+)*`,
			maxLength: 33
		},
		validation: {
			messages: {
				maxLength: 'Your email must be less than 34 characters.'
			}
		}
	},
	drivers_license_front: {
		props: {
			message: `Take a picture of the front of your driver's license.`,
			model_type: 'profile',
			friendly_name: 'Drivers License Front'
		}
	},
	drivers_license_back: {
		props: {
			message: `Take a picture of the back of your driver's license.`,
			model_type: 'profile',
			friendly_name: 'Drivers License Back'
		}
	},
	birth_province: {
		type: 'input',
		props: {
			label: 'Province/State of Birth',
			maxLength: 50
		}
	},
	children: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: 'first_name',
								type: 'name-field',
								props: {
									label: 'First Name',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'last_name',
								type: 'name-field',
								props: {
									label: 'Last Name',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						fieldGroup: [
							{
								key: 'nationality',
								type: 'country-autocomplete',
								props: {
									label: 'Nationality',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'date_of_birth',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'Date of Birth',
									required: true,
									before: [
										{
											date: 'now',
											message: `Date can't be in the future.`
										}
									]
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					}
				]
			},
			defaultValue: [
				null
			]
		}
	},
	past_nationalities: nationalities_object,
	past_permanent_resident: nationalities_object,
	other_valid_visas: nationalities_object,
	countries_visited_in_last_12_months: nationalities_object,
	passport_scan_back: {
		props: {
			type: 'passport_scan',
			message: 'Please take a picture of the back of your passport.',
			model_type: 'profile',
			friendly_name: 'Passport (Back)'
		}
	},
	passport_visa_pages: {
		props: {
			type: 'passport_scan',
			message: 'Please take a picture of two blank visa pages in your passport.',
			model_type: 'profile',
			friendly_name: 'Blank Visa Pages'
		}
	},
	residence_certificate: {
		props: {
			type: 'pdf_document',
			message: 'Please take a picture or upload a copy of your legal residence certificate.',
			model_type: 'profile',
			friendly_name: 'Legal Residence Certificate'
		}
	},
	name_change: {
		previous_name: {
			first_name: FIRST_NAME_FIELD,
			middle_name: MIDDLE_NAME_FIELD,
			last_name: LAST_NAME_FIELD
		},
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						key: 'first_name',
						type: 'name-field',
						props: {
							label: 'First Name',
							'required': true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						key: 'middle_name',
						type: 'name-field',
						props: {
							label: 'Middle Name',
							'required': false
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						key: 'last_name',
						type: 'name-field',
						props: {
							label: 'Last Name',
							'required': true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					}
				],
				fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
			},
			'defaultValue': [
				null
			]
		}
	},
	child_passport: {
		parents: {
			type: 'buttons',
			props: {
				options: [
					{
						label: 'Both',
						value: 'both'
					},
					{
						label: 'One',
						value: 'one'
					}
				]
			}
		},
		sign_form: {
			type: 'yes-no-buttons'
		},
		sole_custody: {
			type: 'yes-no-buttons'
		}
	},
	ds_3053: {
		applying: {
			relationship: {
				type: 'buttons',
				props: {
					options: [
						{
							label: 'Parent',
							value: 'parent'
						},
						{
							label: 'Guardian',
							value: 'guardian'
						},
						{
							label: 'Third Party',
							value: 'third_party'
						}
					]
				}
			},
			first_middle_name: {
				type: 'name-field',
				props: {
					label: 'First and Middle Name',
				}
			},
			last_name: LAST_NAME_FIELD
		},
		non_applying: {
			first_middle_name: {
				type: 'name-field',
				props: {
					label: 'First and Middle Name',
				}
			},
			last_name: LAST_NAME_FIELD,
			address: {
				fieldGroup: US_ADDRESS_FIELDS
			},
			phone: US_PHONE_NUMBER_FIELD,
			email: EMAIL_FIELD
		}
	},
	frequent_traveler: {
		type: 'buttons',
		props: {
			options: [
				{
					label: '1-10 times a year',
					value: 'no'
				},
				{
					label: '10+ times a year',
					value: 'yes'
				}
			]
		}
	},
	large_book: {
		type: 'yes-no-buttons'
	},
	criminal_conviction: {
		answer: {
			type: 'yes-no-buttons'
		},
		over_5_years: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		over_12_months_in_10_years: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		over_12_months: {
			answer: {
				type: 'yes-no-buttons'
			},
			list: {
				type: 'multiple',
				fieldArray: {
					fieldGroup: [
						{
							key: 'description',
							type: 'textarea',
							props: {
								label: 'Description',
								maxLength: 1000
							},
							className: 'gwc-form__field gwc-form__field--grow'
						},
						{
							fieldGroup: [
								{
									key: 'date_of_conviction',
									type: 'datepicker',
									props: {
										label: 'Date of Conviction',
										view: 'multi-year',
									},
									className: 'gwc-form__field gwc-form__field--grow'
								},
								{
									key: 'country_of_conviction',
									type: 'country-autocomplete',
									props: {
										label: 'Country of Conviction',
									},
									className: 'gwc-form__field gwc-form__field--grow'
								}
							],
							fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
						}
					],
					fieldGroupClassName: 'gwc-form__field-group'
				},
				defaultValue: [
					null
				]
			}
		}
	},
	residence_country: {
		type: 'country-autocomplete',
		props: {
			label: 'Country of Residence'
		}
	},
	au: {
		permanent_resident: {
			answer: {
				type: 'yes-no-buttons',
				defaultValue: 'no'
			}
		}
	},
	questions: {
		health: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		special_skills: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		paramilitary: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		organizations: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		family_military_law_enforcement: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		political_party: {
			answer: {
				type: 'yes-no-buttons'
			}
		},
		deported: {
			answer: {
				type: 'yes-no-buttons'
			}
		}
	},
	asylum: {
		answer: {
			type: 'yes-no-buttons'
		}
	},
	refused_entry_any_country: {
		answer: {
			type: 'yes-no-buttons'
		}
	},
	employment_status: {
		start_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				label: 'Start Date',
				after: [
					{
						key: 'date_of_birth',
						parent: 'global',
						message: 'Start date must be after date of birth'
					}
				],
				before: [
					{
						date: 'now',
						message: 'Start date can’t be in the future'
					}
				]
			}
		},
		end_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				label: 'End Date',
				after: [
					{
						key: 'employment_status.start_date',
						parent: 'global',
						message: 'End date must be after start date'
					}
				]
			}
		},
		supervisor: {
			given_name: {
				type: 'name-field',
				props: {
					label: 'First Name'
				}
			},
			last_name: {
				type: 'name-field',
				props: {
					label: 'Last Name'
				}
			},
			phone_number: {
				type: 'masked-input',
				props: {
					mask: '(000) 000-0000',
					label: `Supervisor's Phone`
				}
			}
		},
		previous: {
			type: 'yes-no-buttons'
		},
		business_card: {
			props: {
				message: 'Please take a picture of your business card.',
				friendly_name: 'Business Card'
			}
		},
		list: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: 'employer',
								type: 'input',
								props: {
									label: 'Employer',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'position',
								type: 'input',
								props: {
									label: 'Position',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						fieldGroup: [
							{
								key: 'start_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'Start Date',
								}
							},
							{
								key: 'end_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'End Date',
								}
							}
						]
					},
					{
						fieldGroup: [
							{
								key: 'supervisor.given_name',
								type: 'name-field',
								props: {
									label: 'First Name',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'supervisor.last_name',
								type: 'name-field',
								props: {
									label: 'Last Name',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						key: 'supervisor.phone_number',
						type: 'input',
						props: {
							label: `Supervisor's Phone`,
							required: true,
							maxLength: 20
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						key: 'description',
						type: 'input',
						props: {
							label: 'Description',
							required: true,
							maxLength: 100
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						key: 'phone_number',
						type: 'input',
						props: {
							label: 'Phone Number',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					...INT_ADDRESS_FIELDS,
				],
				fieldGroupClassName: 'gwc-form__field-group'
			},
			defaultValue: [
				null
			]
		},
		unemployment_type: {
			type: 'select',
			props: {
				label: 'Employment Status',
				options: [
					{
						label: 'Housewife',
						value: 'housewife'
					},
					{
						label: 'Retired',
						value: 'retired'
					},
					{
						label: 'Unemployed',
						value: 'unemployed'
					}
				],
			}
		},
		website: {
			type: 'input',
			props: {
				label: 'Website',
				pattern: '(https?://)?(www\\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)',
				maxLength: 255
			},
			className: 'gwc-form__field gwc-form__field--grow',
			'validation': {
				messages: {
					maxLength: 'Your email must be less than 34 characters.'
				}
			}
		},
		answer: {
			type: 'yes-no-buttons'
		},
		status: {
			type: 'select',
			props: {
				label: 'Employment Status',
				options: [
					{
						label: 'Employed',
						value: 'employed'
					},
					{
						label: 'Self-Employed',
						value: 'self_employed'
					},
					{
						label: 'Student',
						value: 'student'
					},
					{
						label: 'Official',
						value: 'official'
					}
				]
			}
		},
		employer: {
			type: 'input',
			props: {
				label: 'Employer',
				'required': true,
				maxLength: 50
			}
		},
		position: {
			type: 'input',
			props: {
				label: 'Position',
				'required': true,
				maxLength: 50
			}
		},
		salary: {
			type: 'input',
			props: {
				'min': 0,
				'step': 1,
				type: 'number',
				label: 'MonthlySalary (USD)',
				'required': true
			}
		},
		description: {
			type: 'input',
			props: {
				label: 'Job Description',
				'required': true,
				maxLength: 100
			}
		},
		email: EMAIL_FIELD,
		phone_number: US_PHONE_NUMBER_FIELD,
		address: {
			fieldGroup: US_ADDRESS_FIELDS,
		}
	},
	emergency_contact: {
		answer: {
			type: 'yes-no-buttons'
		},
		relationship: {
			type: 'input',
			props: {
				label: 'Relationship',
				maxLength: 70
			}
		},
		first_name: FIRST_NAME_FIELD,
		middle_name: MIDDLE_NAME_FIELD,
		last_name: LAST_NAME_FIELD,
		address: {
			country: CA_COUNTRY_FIELD,
			fieldGroup: [
				{
					fieldGroup: [
						{
							key: "number",
							type: "input",
							props: {
								label: "Number",
								maxLength: 5,
								pattern: "^[ \\-a-zA-Z0-9]*$",
								required: true
							},
							className: "gwc-form__field gwc-form__field--grow gwc-form__field--small",
							validators: {
								validation: [
									"pobox"
								]
							}
						},
						{
							key: "street",
							type: "input",
							props: {
								label: "Street",
								maxLength: 30,
								required: true
							},
							className: "gwc-form__field gwc-form__field--grow",
							validators: {
								validation: ["pobox"]
							}
						},
						{
							key: 'apt',
							type: 'input',
							props: {
								label: 'Suite/Apt',
								required: false
							},
							className: 'gwc-form__field gwc-form__field--apt',
							validators: {
								validation: [
									'pobox'
								]
							}
						}
					],
					fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
				},
				...US_ADDRESS_FIELDS.slice(0, 1),
				{
					fieldGroup: [
						{
							key: 'city',
							type: 'name-field',
							props: {
								label: 'City',
								required: true
							},
							className: 'gwc-form__field gwc-form__field--grow'
						},
						{
							key: "state",
							type: "autocomplete",
							props: {
								required: true,
								mappedOptions: STATE_PROVINCE_LIST,
							},
							expressions: {
								'props.label': (field: FormlyFieldConfig) => {
									const parent = field.parent?.parent
									const country = parent ? parent?.model?.country || parent.parent?.props?.['country'] : null

									return country === 'CA' ? 'Province' : 'State'
								},
								'props.options': (field: FormlyFieldConfig) => {
									const parent = field.parent?.parent
									const country = parent ? parent?.model?.country || parent.parent?.props?.['country'] : null

									return field.props?.['mappedOptions'][country || 'US']
								}
							},
							className: "gwc-form__field gwc-form__field--grow"
						},
						{
							key: "zip",
							type: "input",
							props: {
								label: "Zip",
								required: true
							},
							className: "gwc-form__field gwc-form__field--grow gwc-form__field--small",
							expressions: {
								'props.pattern': (field: FormlyFieldConfig) => {
									const country = field.formControl?.parent?.get('country')?.value || field.model?.country || field.parent?.parent?.parent?.props?.['country']

									return country === 'CA' ? '[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz] \\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\\d' : '[0-9]{5}'
								},
								'props.maxLength': (field: FormlyFieldConfig) => {
									const country = field.formControl?.parent?.get('country')?.value || field.model?.country

									return country === 'CA' ? 7 : 5
								},
							}
						}
					],
					fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
				}
			],
		},
		phone_number: US_PHONE_NUMBER_FIELD,
		extra_number: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Additional Number',
				required: false
			}
		},
		email: EMAIL_FIELD,
	},
	issued_passports: {
		type: 'buttons',
		props: {
			options: [
				{
					label: 'Passport Book',
					value: 'book'
				},
				{
					label: 'Passport Card',
					value: 'card'
				},
				{
					label: 'Both',
					value: 'both'
				},
				{
					label: 'None',
					value: 'none'
				}
			],
		}
	},
	application: application_fields,
	mother: {
		...relative_object,
		former_surnames: {
			type: 'name-field',
			props: {
				label: 'All former surname(s)',
				required: false
			}
		},
		address: {
			type: 'ca-plain-address-country'
		},
		phone_number: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (primary)'
			}
		},
		phone_other: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (other)'
			}
		},
		birth_certificate_match: {
			type: 'yes-no-buttons'
		},
		name_change_scan: {
			props: {
				type: 'secure-scanner',
				message: 'Please upload document confirming name change from birth certificate.',
				friendly_name: 'Name Change Confirmation'
			}
		},
		in_us: {
			type: 'yes-no-buttons'
		},
		status_in_us: {
			type: 'select',
			props: {
				label: 'Status in the United States',
				options: [
					{ label: 'U.S. Citizen', value: 'S' },
					{ label: 'U.S. Legal Permanent Resident (LPR)', value: 'C' },
					{ label: 'Nonimmigrant', value: 'P' },
					{ label: `Other/I Don't Know`, value: 'O' }
				]
			}
		}
	},
	guardian_1: {
		...relative_object,
		former_surnames: {
			type: 'name-field',
			props: {
				label: 'All former surname(s)',
				required: false
			}
		},
		address: {
			type: 'ca-plain-address-country'
		},
		phone_number: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (primary)'
			}
		},
		phone_other: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (other)'
			}
		}
	},	guardian_2: {
		...relative_object,
		former_surnames: {
			type: 'name-field',
			props: {
				label: 'All former surname(s)',
				required: false
			}
		},
		address: {
			type: 'ca-plain-address-country'
		},
		phone_number: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (primary)'
			}
		},
		phone_other: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (other)'
			}
		}
	},
	father: {
		...relative_object,
		former_surnames: {
			type: 'name-field',
			props: {
				label: 'All former surname(s)',
				required: false
			}
		},
		address: {
			type: 'ca-plain-address-country'
		},
		phone_number: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (primary)'
			}
		},
		phone_other: {
			type: 'masked-input',
			props: {
				mask: '(000) 000-0000',
				label: 'Telephone (other)'
			}
		},
		in_us: {
			type: 'yes-no-buttons'
		},
		status_in_us: {
			type: 'select',
			props: {
				label: 'Status in the United States',
				options: [
					{ label: 'U.S. Citizen', value: 'S' },
					{ label: 'U.S. Legal Permanent Resident (LPR)', value: 'C' },
					{ label: 'Nonimmigrant', value: 'P' },
					{ label: `Other/I Don't Know`, value: 'O' }
				]
			}
		}
	},
	divorced_widowed: {
		former_spouses: {
			type: 'multiple',
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: 'spouse.given_name',
								type: 'name-field',
								props: {
									label: 'Given Names',
									maxLength: 33
								}
							},
							{
								key: 'spouse.last_name',
								type: 'name-field',
								props: {
									label: 'Last Name',
									maxLength: 33
								}
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						'template': '<div class=\'gwc-form__label\'>When and where were they born?</div>'
					},
					{
						key: 'spouse.date_of_birth',
						type: 'datepicker',
						props: {
							view: 'multi-year',
							after: [
								{
									key: 'date_of_birth',
									parent: 'global',
									message: `Date must be after the applicant's date of birth`
								}
							]
						}
					},
					{
						fieldGroup: [
							{
								key: 'spouse.birth_country',
								type: 'country-autocomplete',
								props: {
									label: 'Birth Country',
									required: true
								}
							},
							{
								key: 'spouse.birth_city',
								type: 'input',
								props: {
									label: 'City',
									maxLength: 20
								}
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						'template': '<div class=\'gwc-form__label\'>Were they a U.S. Citizen?</div>'
					},
					{
						key: 'spouse.us_citizen',
						type: 'yes-no-buttons'
					},
					{
						'template': '<div class=\'gwc-form__label\'>What was their nationality?</div>'
					},
					{
						key: 'spouse.nationality',
						type: 'country-autocomplete',
						props: {
							label: 'Nationality',
						}
					},
					{
						'template': '<div class=\'gwc-form__label\'>When did you get married to them?</div>'
					},
					{
						key: 'date_of_marriage',
						type: 'datepicker',
						props: {
							view: 'multi-year',
							after: [
								{
									key: 'date_of_birth',
									parent: 'global',
									message: `Date must be after the applicant's date of birth`
								}
							]
						}
					},
					{
						'template': '<div class=\'gwc-form__label\'>When and wheredid you get divorced?</div>'
					},
					{
						fieldGroup: [
							{
								key: 'date_of_divorce',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									after: [
										{
											key: 'date_of_birth',
											parent: 'global',
											message: `Date must be after the applicant's date of birth`
										}
									]
								}
							},
							{
								key: 'location_of_divorce',
								type: 'country-autocomplete',
								props: {
									label: 'Country',
								}
							}
						]
					},
					{
						'template': '<div class=\'gwc-form__label\'>How did the marriage ended?</div>'
					},
					{
						type: 'textarea',
						props: {
							label: 'Please provide details',
							rows: 2,
						}
					}
				]
			}
		},
		answer: {
			type: 'yes-no-buttons'
		},
		date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						key: 'date_of_birth',
						parent: 'global',
						message: `Date must be after the applicant's date of birth`
					},
					{
						key: 'divorced_widowed.spouse.date_of_birth',
						parent: 'global',
						message: `Date can’t be before spouse's date of birth`
					}
				],
				label: 'Date of Marriage',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					},
					{
						key: 'divorced_widowed.date_of_divorce',
						parent: 'global',
						message: 'Date must be before the divorce date'
					}
				]
			}
		},
		spouse: {
			...spouse_object,
			address: {
				fieldGroup: INT_ADDRESS_FIELDS
			}
		},
		date_of_divorce: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						key: 'divorced_widowed.date',
						parent: 'global',
						message: 'Date can’t be before the marriage date'
					},
					{
						key: 'date_of_birth',
						parent: 'global',
						message: `Date must be after the applicant's date of birth`
					},
					{
						key: 'divorced_widowed.spouse.date_of_birth',
						parent: 'global',
						message: `Date can’t be before spouse's date of birth`
					}
				],
				label: 'Date of Divorce or Death',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				]
			}
		}
	},
	married: {
		answer: {
			type: 'yes-no-buttons'
		},
		spouse: spouse_object,
		date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						key: 'date_of_birth',
						parent: 'global',
						message: 'Date can’t be before applicant’s date of birth'
					},
					{
						key: 'married.spouse.date_of_birth',
						parent: 'global',
						message: `Date can’t be before spouse's date of birth`
					}
				],
				label: 'Date of Marriage',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				]
			}
		}
	},
	uscis_number: {
		answer: {
			type: 'yes-no-buttons'
		},
		value: {
			type: 'masked-input',
			props: {
				'mask': '000000000',
				label: 'USCIS Registration Number (A-Number)',
				pattern: '^[0-9]{9}$'
			}
		}
	},
	taxpayer_id: {
		answer: {
			type: 'yes-no-buttons'
		},
		value: {
			type: 'input',
		}
	},	
	social_security_available: {
		type: 'yes-no-buttons'
	},
	social_security: {
		type: 'social-security-input',
		props: {
			'minLength': 9,
			maxLength: 9
		}
	},
	passport: {
		type: {
			type: 'select',
			props: {
				label: 'Passport Type',
				options: [
					{
						label: 'Regular',
						value: 'regular'
					},
					{
						label: 'Service',
						value: 'service'
					},
					{
						label: 'Diplomatic',
						value: 'diplomatic'
					},
					{
						label: 'Official',
						value: 'official'
					}
				]
			}
		},
		in_possession: {
			type: 'buttons',
			props: {
				options: [
					{
						label: 'Yes',
						value: 'yes'
					},
					{
						label: 'No, it was lost',
						value: 'lost'
					},
					{
						label: 'No, it was stolen',
						value: 'stolen'
					}
				],
			}
		},
		is_damaged: {
			type: 'yes-no-buttons'
		},
		first_name: FIRST_NAME_FIELD,
		middle_name: MIDDLE_NAME_FIELD,
		last_name: LAST_NAME_FIELD,
		native_name: {
			answer: {
				type: 'yes-no-buttons'
			},
			value: {
				type: 'input',
				props: {
					label: 'Native Name'
				}
			}
		},
		telecode: {
			answer: {
				type: 'yes-no-buttons'
			},
			value: {
				type: 'input',
				props: {
					label: 'Native Name'
				}
			}
		},
		issuer: {
			type: 'input',
			props: {
				label: 'Issuing Authority/Place of Issue'
			}
		},
		issued_at: {
			country: {
				type: 'country-autocomplete',
				props: {
					label: 'Country'
				}
			},
			state: {
				type: 'input',
				props: {
					label: 'State',
					maxLength: 25
				}
			},
			city: {
				type: 'input',
				props: {
					label: 'City',
					maxLength: 25
				}
			}
		},
		number: {
			type: 'input',
			props: {
				label: 'Passport Number',
				pattern: '[a-zA-Z0-9]{9}',
				'required': true
			},
			'expressions': {
				'props.pattern': `model.citizenship === 'US' ? '[a-zA-Z0-9]{9}' : '[a-zA-Z0-9]{7,9}'`
			}
		},
		issue_date: {
			key: 'passport.issue_date',
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						key: 'date_of_birth',
						parent: 'global',
						message: 'Date can’t be before applicant’s date of birth'
					}
				],
				label: 'Date of Issue',
				before: [
					{
						date: 'now',
						message: 'Date can’t be in the future'
					}
				]
			},
		},
		expiry_date: {
			type: 'datepicker',
			props: {
				view: 'multi-year',
				after: [
					{
						date: 'now',
						message: 'Date can’t be in the past'
					}
				],
				label: 'Date of Expiry',
			}
		}
	},
	military: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'country',
						type: 'country-autocomplete',
						props: {
							label: 'Country',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						'fieldGroup': [
							{
								key: 'branch',
								type: 'input',
								props: {
									label: 'Branch of Service',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'rank',
								type: 'input',
								props: {
									label: 'Rank',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					},
					{
						key: 'specialty',
						type: 'input',
						props: {
							label: 'Specialty',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						fieldGroup: [
							{
								key: 'start_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'Start Date',
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'end_date',
								type: 'datepicker',
								props: {
									view: 'multi-year',
									label: 'End Date',
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					}
				]
			}
		}
	},
	paramilitary_organizations: {
		answer: {
			type: 'yes-no-buttons'
		},
		description: {
			type: 'textarea',
			props: {
				label: 'Please provide additional details about your involvement with paramilitary organizations.',
			}
		}
	},
	travel_history: {
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'country',
						type: 'country-autocomplete',
						props: {
							label: 'Country',
							required: true
						}
					}
				],
				fieldGroupClassName: 'gwc-form__field-group'
			}
		}
	},
	specialized_training: {
		answer: {
			type: 'yes-no-buttons'
		},
		description: {
			type: 'textarea',
			props: {
				label: 'Please provide a description of your specialized skills or training.',
				required: true,
				rows: 2
			}
		}
	},
	charitable_organizations: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'name',
						type: 'input',
						props: {
							label: 'Organization Name',
							required: true,
							maxLength: 66
						}
					}
				]
			}
		}
	},
	countries_visited_in_last_5_years: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			'fieldArray': {
				fieldGroup: [
					{
						key: 'code',
						type: 'country-autocomplete',
						className: 'gwc-form__field gwc-form__field--grow'
					}
				]
			},
			'defaultValue': [
				null
			]
		}
	},
	countries_visited_in_last_10_years: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'multiple',
			'fieldArray': {
				fieldGroup: [
					{
						key: 'code',
						type: 'country-autocomplete',
						className: 'gwc-form__field gwc-form__field--grow'
					}
				]
			},
			'defaultValue': [
				null
			]
		}
	},
	resided_in_other_countries: {
		answer: {
			type: 'yes-no-buttons'
		},
		list: {
			type: 'array',
			fieldArray: {
				fieldGroup: [
					{
						key: 'code',
						type: 'country-autocomplete',
						props: {
							label: 'Country',
							required: true
						},
						className: 'gwc-form__field gwc-form__field--grow'
					},
					{
						fieldGroup: [
							{
								key: 'start',
								type: 'input',
								props: {
									type: 'number',
									min: 1900,
									max: 2100,
									step: 1,
									label: 'From Year',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							},
							{
								key: 'to',
								type: 'input',
								props: {
									type: 'number',
									min: 1900,
									max: 2100,
									step: 1,
									label: 'To Year',
									required: true
								},
								className: 'gwc-form__field gwc-form__field--grow'
							}
						],
						fieldGroupClassName: 'gwc-form__field-group gwc-form__field-group--row'
					}
				],
				fieldGroupClassName: 'gwc-form__field-group'
			},
			defaultValue: [
				null
			]
		}
	}
}

export const buildField = (field: any) => {
	let new_field = { ...field }

	if (!field.fieldGroup) {
		console.log('field not found', field)
	}

	new_field.fieldGroup = field.fieldGroup.map((field_item: any) => {
		if (field_item.fieldGroup) {
			return buildField(field_item)
		} else if (field_item.key) {
			let field_base = _.get(fields, field_item.key)
			if (!field_base) {
				console.log('field_base not found', field_item.key)
				return field_item
			}

			let field_object = {
				...field_base,
				props: {
					...(field_base.props || {}),
					required: field_item.required
				},
				key: field_item.key,
				...(field_item.expressions && { expressions: field_item.expressions }),
				className: 'gwc-form__field gwc-form__field--grow'
			}

			if (field_item.type === 'object') {
				const subkeys = field_item.subkeys.map((subkey: { key: string, required: boolean }) => subkey.key)

				field_object = filterFieldGroup(field_object, subkeys)
			} else if (field_item.type === 'array') {
				const subkeys = field_item.subkeys.map((subkey: { key: string, required: boolean }) => subkey.key)
				field_object.fieldArray = filterFieldGroup(field_object.fieldArray , subkeys)
			}

			return field_object
		}

		return field_item
	})

	return new_field
}

const filterFieldGroup = (field: any, subkeys: string[]) => {
	let new_field_group: FormlyFieldConfig[] = []

	field.fieldGroup.forEach((field: any) => {
		if (field.fieldGroup) {
			new_field_group.push(filterFieldGroup(field, subkeys))
		} else if (field.key) {
			if (subkeys.includes(field.key)) {
				new_field_group.push(field)
			}
		}
	})

	new_field_group = new_field_group.filter((field: any) => field !== null)

	if (new_field_group.length === 0) {
		return null
	}

	return { ...field, fieldGroup: new_field_group }
}
